"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Download___StyledSvg",
  componentId: "sc-1h5nteu-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Download(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M449 294.2c-3.271-30.543-23.071-56.1-50.471-67.5.128-2.486.4-4.986.4-7.471 0-3.929-.129-7.729-.529-11.529-5.771-63.443-59.243-113.257-124.257-113.257-49.672 0-92.543 29.1-112.6 71.171-9.7-7.6-21.886-12.057-35.257-12.057-31.857 0-57.543 25.829-57.543 57.543v1.971a53.017 53.017 0 002.628 15.2c-22.414 13.243-38.142 36.572-41.028 63.7-.129 2.886-.257 5.9-.257 8.915 0 34.728 20.971 64.614 50.985 77.6 9.829 4.328 20.715 6.686 32.115 6.814h126.5c-3.015-.4-5.9-1.971-8.257-4.714l-73.143-87.043c-5.372-6.429-2.886-11.529 5.371-11.529H217v-81.271h47.586v81.271h53.471c8.257 0 10.743 5.243 5.372 11.529l-73.015 87.171c-2.357 2.758-5.243 4.329-8.257 4.715H362.23c1.442.128 3.014.257 4.457.257 16.128 0 31.071-4.586 43.785-12.586 23.329-14.543 38.929-40.5 38.929-70.128.129-3.015 0-5.9-.4-8.786v.014z"
  }));
}

var _default = Download;
exports["default"] = _default;